// Ворота отправки заявки на /zal (спека 2026-10-13 п.10, переделка 2026-10-14 п.3).
// Чистые функции, DOM-обвязка — в hallForm.ts. Кнопка всегда активна: на отправке
// гейт либо пропускает, либо называет, чего не хватает. Без JS работает нативный required.

export interface MissingField {
  label: string
  // Что подсвечивать и куда ставить фокус: элементы строки перечня (у группы радиокнопок
  // их несколько, фокус — на первый) или их видимые заместители из data-field-proxy.
  fields: HTMLElement[]
  // Поле заполнено, но не прошло проверку (дата вне min/max и т.п.): в подсказке «Проверьте».
  invalid: boolean
}

export interface HallGateInput {
  missing: MissingField[]
  // Капча включена: на странице есть виджет. Выключенная капча условие по токену снимает.
  captchaRequired: boolean
  token: string
}

// Поля и капча — независимые условия: подсказка называет оба сразу.
export interface HallGateState {
  ready: boolean
  missing: MissingField[]
  captchaPending: boolean
}

export function hallGateState({ missing, captchaRequired, token }: HallGateInput): HallGateState {
  const captchaPending = captchaRequired && token.trim() === ''
  return { ready: !missing.length && !captchaPending, missing, captchaPending }
}

type Control = HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement

// Подпись строки: data-field-label (строчными, как в фразе «заполните: телефон»), иначе
// подпись поля из разметки зала, иначе имя поля — пусть криво, но не пусто.
function fieldLabel(field: Control): string {
  return field.dataset.fieldLabel
    || field.closest('label')?.querySelector('.hl__label')?.textContent?.trim()
    || field.name
}

// Скрытое поле (значение сетки часов) само на экране не видно: подсветку и фокус оно
// отдаёт видимому элементу, чей id лежит в data-field-proxy. Нет такого — поле само.
function highlightTarget(field: Control): HTMLElement {
  const proxyId = field.dataset.fieldProxy
  return (proxyId && field.ownerDocument.getElementById(proxyId)) || field
}

// validity, а не checkValidity(): последний шлёт событие invalid на каждом пересчёте.
// Отключённое поле браузер не отправляет и не валидирует — пропускаем. Радиокнопки
// одной группы делят подпись и сливаются в одну строку.
export function missingRequiredFields(form: HTMLFormElement): MissingField[] {
  const byLabel = new Map<string, MissingField>()
  form.querySelectorAll<Control>('[required]').forEach((field) => {
    if (field.disabled || field.validity.valid) return

    const label = fieldLabel(field)
    const invalid = !field.validity.valueMissing
    const target = highlightTarget(field)
    const known = byLabel.get(label)
    if (known) {
      known.fields.push(target)
      known.invalid = known.invalid && invalid
    } else byLabel.set(label, { label, fields: [target], invalid })
  })
  return Array.from(byLabel.values())
}
